export let fadeIn = {
  show: { 
    opacity: 1,
    x: 0,
    transition: { 
      ease: "easeIn", 
      duration: 0.5,
    }
  },
  hidden: { 
    opacity: 0,
    x: -20,
  },
};

export let container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      ease: "easeIn",
      staggerChildren: 0.4,
      delayChildren: 0.4
    }
  }
}